const calloutComponentInputTimeValidator = (_schema, _answer) => {
  throw new Error(`[calloutComponentInputTimeValidator] Not implemented yet`);
};
export {
  calloutComponentInputTimeValidator
};
